import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import {
  buildRoute,
  humanize,
  isListedPumpPrice,
  metaFuel,
  parseJSONError,
} from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) and $context are loaded globally

class ChargeItemForm extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      ...this.getStateFromChargeItem(this.props.chargeItem),
      validationMessage: "",
      processing: false,
      processingDelete: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.handleInputChange = this.handleInputChange.bind(this)
    this.toggleTaxIncluded = this.toggleTaxIncluded.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.finish = this.finish.bind(this)
    this.createCharge = this.createCharge.bind(this)
    this.updateCharge = this.updateCharge.bind(this)
    this.renderCategoryOptions = this.renderCategoryOptions.bind(this)
    this.renderFrequencyOptions = this.renderFrequencyOptions.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chargeItem !== this.props.chargeItem) {
      this.setState(this.getStateFromChargeItem(this.props.chargeItem))
    }
  }

  getStateFromChargeItem(chargeItem) {
    return {
      name: chargeItem ? chargeItem.name : "",
      category: chargeItem ? chargeItem.category : this.props.categories[0],
      frequency:
        chargeItem && chargeItem.frequency ? chargeItem.frequency : "one_time",
      price: chargeItem && chargeItem.unitPrice ? chargeItem.unitPrice : "",
      taxRate: chargeItem ? chargeItem.taxRate : "",
      taxIncluded: chargeItem ? chargeItem.taxIncluded : false,
      quantity: chargeItem && chargeItem.quantity ? chargeItem.quantity : "",
      sku: chargeItem && chargeItem.sku ? chargeItem.sku : null,
    }
  }

  processingDelete() {
    return (
      this.props.chargeItem &&
      this.props.processingDelete === this.props.chargeItem.id
    )
  }

  pricePrecision() {
    return metaFuel(this.state.category) ? "4" : "2"
  }

  handleCancel() {
    this.props.showForm(false, null)
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.submit()
    }
  }

  toggleTaxIncluded(event) {
    event.target.checked
      ? this.setState({ taxRate: "", taxIncluded: true })
      : this.setState({ taxIncluded: false })
  }

  submit() {
    this.setState({ processing: true })
    const params = {
      name: this.state.name,
      category: this.state.category,
      frequency: this.state.frequency,
      tax_rate: this.state.taxRate,
      item_price: this.state.price,
      quantity: this.state.quantity,
      tax_included: this.state.taxIncluded,
      sku: this.state.sku,
    }

    const isNewPumpPriceItem =
      this.props.chargeItem &&
      !this.props.chargeItem.id &&
      isListedPumpPrice(this.props.chargeItem)
    const isListedPumpPriceName = Object.keys($context.listedPumpPrices)
      .map((name) => name.toLowerCase())
      .includes(this.state.name.toLowerCase())
    if (
      !isNewPumpPriceItem &&
      isListedPumpPriceName &&
      !isListedPumpPrice(this.props.chargeItem)
    ) {
      this.setState({
        processing: false,
        validationMessage: "Items names can not match Listed Pump Prices",
      })
    } else if (this.props.chargeItem && !isNewPumpPriceItem) {
      this.updateCharge(params)
    } else {
      this.createCharge(params)
    }
  }

  createCharge(params) {
    $.post(
      $context.createUrl,
      params,
      (data) => {
        this.props.createChargeItem(data)
      },
      "json"
    ).fail((data) => {
      this.setState({
        validationMessage:
          parseJSONError(data.responseText) ||
          "There was an error processing your request.",
        processing: false,
      })
    })
  }

  updateCharge(params) {
    $.ajax({
      url: buildRoute($context.updateUrl, {
        charge_item_id: this.props.chargeItem.id,
      }),
      data: JSON.stringify(params),
      type: "PATCH",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        this.props.updateChargeItem(data)
      },
      error: (data) => {
        this.setState({
          validationMessage:
            parseJSONError(data.responseText) ||
            "There was an error processing your request.",
          processing: false,
        })
      },
    })
  }

  renderCategoryOptions() {
    return _.map(this.props.categories, (category) => (
      <option key={category} value={category}>
        {humanize(category)}
      </option>
    ))
  }

  renderFrequencyOptions() {
    return _.map(this.props.frequencies, (frequency) => (
      <option key={frequency} value={frequency}>
        {humanize(frequency)}
      </option>
    ))
  }

  handleDeleteClick() {
    this.props.deleteChargeItem(this.props.chargeItem)
  }

  render() {
    return (
      <div className="my-8 flex justify-center">
        <div className="max-w-7xl">
          <div className="row-flex form-row">
            <div className="col-xs-4">
              <FormGroup
                label="Item Name"
                name="name"
                value={this.state.name}
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "name",
                  this.state.name,
                  "required"
                )}
                disabled={isListedPumpPrice(this.props.chargeItem)}
              />
            </div>
            <div className="col-xs-4">
              <FormGroup
                inputType="select"
                label="Category"
                name="category"
                value={this.state.category}
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "category",
                  this.state.category,
                  "required"
                )}
                disabled={isListedPumpPrice(this.props.chargeItem)}
              >
                <option disabled={true}>Select Category</option>
                {this.renderCategoryOptions()}
              </FormGroup>
            </div>
            <div className="col-xs-4">
              <FormGroup
                inputType="select"
                label="Frequency"
                name="frequency"
                value={
                  this.state.category === "metered_electric"
                    ? "one_time"
                    : this.state.frequency
                }
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "frequency",
                  this.state.frequency,
                  "required"
                )}
                disabled={
                  isListedPumpPrice(this.props.chargeItem) ||
                  this.state.category === "metered_electric"
                }
              >
                {this.renderFrequencyOptions()}
              </FormGroup>
            </div>
            <div className="col-xs-4">
              <FormGroup
                inputType="currency"
                label="Default Unit Price"
                name="price"
                value={this.state.price}
                onChange={this.handleInputChange}
                validation={this.validator.message(
                  "price",
                  this.state.price,
                  `maxDecimalPrecision:${this.pricePrecision()}`
                )}
              />
            </div>
            <div className="col-xs-4">
              <FormGroup
                inputType="percentage"
                label="Default Tax"
                name="taxRate"
                value={this.state.taxRate}
                onChange={this.handleInputChange}
                className="mb-2"
                disabled={this.state.taxIncluded}
                validation={this.validator.message(
                  "tax",
                  this.state.taxRate,
                  "numeric|min:0,num"
                )}
              />
              <FormGroup
                inputType="checkbox"
                label="Tax included in price"
                labelClassName="text-gray-500 font-normal pl-1"
                name="tax_included"
                value={this.state.taxIncluded}
                onChange={this.toggleTaxIncluded}
                className="mb-0 ml-0.5 mt-0 flex cursor-pointer pl-4"
              />
            </div>
            <div className="col-xs-4">
              <FormGroup
                inputType="select"
                label="Default Quantity"
                name="quantity"
                value={this.state.quantity}
                onChange={this.handleInputChange}
                disabled={isListedPumpPrice(this.props.chargeItem)}
              >
                <option value="" />
                <option value="1">1</option>
              </FormGroup>
            </div>
            {$context.inventoryPropertiesEnabled && (
              <div className="col-xs-4">
                <FormGroup
                  label="SKU"
                  name="sku"
                  value={this.state.sku}
                  onChange={this.handleInputChange}
                  className="mb-2"
                />
              </div>
            )}
            {this.validator.messageWhenPresent(this.state.validationMessage, {
              className: "bs-mb-3 text-danger text-bold",
            })}
          </div>
          <div className="mt-6 flex items-center">
            {this.props.chargeItem && (
              <NextButton
                click={this.handleDeleteClick}
                processing={this.processingDelete()}
                processingText="Deleting Item..."
                icon=""
                text="Delete Item"
                btnClass={`btn btn-danger ${
                  isListedPumpPrice(this.props.chargeItem) ? "invisible" : ""
                }`}
              />
            )}
            <button
              type="button"
              className="btn btn-secondary ml-auto"
              disabled={this.processingDelete()}
              onClick={this.handleCancel}
            >
              Cancel
            </button>
            <NextButton
              click={this.finish}
              processing={this.state.processing}
              disabled={this.processingDelete()}
              processingText={
                this.props.chargeItem ? " Updating Item" : " Creating Item"
              }
              icon=""
              text={this.props.chargeItem ? "Update Item" : "Create Item"}
              btnClass="btn btn-primary ml-4"
            />
          </div>
        </div>
      </div>
    )
  }
}

ChargeItemForm.propTypes = {
  chargeItem: PropTypes.object,
  showForm: PropTypes.func.isRequired,
  createChargeItem: PropTypes.func.isRequired,
  updateChargeItem: PropTypes.func.isRequired,
  deleteChargeItem: PropTypes.func.isRequired,
  processingDelete: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  categories: PropTypes.array.isRequired,
  frequencies: PropTypes.array.isRequired,
}

export default ChargeItemForm
